var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Group, Rect } from '../../element';
import { isNumber, max } from '../../utils/lodash';
export function getDefaultZoneOption() {
    return {
        zoneAxis: 'y',
        zones: [],
    };
}
export function getClipOffset(lineModel) {
    var _a = lineModel.getOption(), zones = _a.zones, defaultLineStyle = _a.lineStyle;
    if (zones.length === 0) {
        return defaultLineStyle.lineWidth / 2;
    }
    return (max(zones.map(function (zone) {
        var style = __assign(__assign({}, defaultLineStyle), zone.lineStyle);
        return style.lineWidth;
    })) / 2);
}
export function renderZone(lineModel, type) {
    var _a = lineModel.getOption(), zoneAxis = _a.zoneAxis, zones = _a.zones, defaultLineStyle = _a.lineStyle, defaultAreaStyle = _a.areaStyle;
    var defaultColor = lineModel.getSeriesColor();
    var defaultFillColor = lineModel.getSeriesColor(true);
    var coord = lineModel.getCoord();
    if (zones.length === 0 || coord.coordinateSystem !== 'cartesian2d') {
        if (type === 'line') {
            return lineModel.renderLine(defaultLineStyle, defaultColor, lineModel.lineGroupRef);
        }
        if (type === 'area') {
            return lineModel.renderFillArea(defaultAreaStyle, defaultFillColor);
        }
    }
    var xScale = coord.getXAxis().scale;
    var yScale = coord.getYAxis().scale;
    var _b = coord.getXAxis().parentModel.getState(), top = _b.top, left = _b.left, right = _b.right, bottom = _b.bottom;
    var clipOffset = getClipOffset(lineModel);
    top -= clipOffset;
    left -= clipOffset;
    right += clipOffset;
    bottom += clipOffset;
    var group = new Group({
        key: lineModel.getKey('zone' + type),
        ref: lineModel.lineGroupRef,
        clip: lineModel.clipPath,
    });
    function getValue(value, minValue, maxValue) {
        if (isNumber(value)) {
            return value;
        }
        if (value === 'min') {
            return minValue;
        }
        if (value === 'max') {
            return maxValue;
        }
    }
    zones.forEach(function (zone, index) {
        var start = zone.start, end = zone.end, color = zone.color, lineStyle = zone.lineStyle, areaStyle = zone.areaStyle;
        var areaTarget;
        if (type === 'line') {
            areaTarget = lineModel.renderLine(__assign(__assign({}, defaultLineStyle), lineStyle), color || defaultColor, undefined, zone);
        }
        else {
            areaTarget = lineModel.renderFillArea(__assign(__assign({}, defaultAreaStyle), areaStyle), color || defaultColor);
        }
        var scale = zoneAxis === 'x' ? xScale : yScale;
        var startValue = getValue(start, scale.min, scale.max);
        var endValue = getValue(end, scale.min, scale.max);
        var startPosition = scale.scale(startValue);
        var endPosition = scale.scale(endValue);
        var x;
        var y;
        var width;
        var height;
        if (zoneAxis === 'x') {
            x = startPosition;
            y = top;
            width = endPosition - startPosition;
            height = bottom - top;
        }
        else if (zoneAxis === 'y') {
            x = left;
            y = startPosition;
            width = right;
            height = endPosition - startPosition;
        }
        var clip = new Rect({
            x: x,
            y: y,
            width: width,
            height: height,
        });
        areaTarget.setAttr({
            key: lineModel.getKey('zone-item-' + index),
            clip: clip,
        });
        group.add(areaTarget);
    });
    return group;
}
